import { differenceInCalendarDays as dfnsDifferenceInCalendarDays, intervalToDuration } from 'date-fns';

import type { ComparableDate, DateDifference, DateUnit } from '../types';
import { parseDate } from './parsing';
import { getToday } from './utils';

export const compareDate = (date: string): ComparableDate => {
  const parsed = parseDate(date);
  const time = parsed.getTime();

  return {
    isAfter: (comparator: string) => time > parseDate(comparator).getTime(),
    isBefore: (comparator: string) => time < parseDate(comparator).getTime(),
    isEqual: (comparator: string) => time === parseDate(comparator).getTime(),
    isSame: (comparator: string, unit: DateUnit) => {
      const compared = parseDate(comparator);

      if (unit === 'day') return parsed.getDate() === compared.getDate();
      if (unit === 'month') return parsed.getMonth() === compared.getMonth();

      return parsed.getFullYear() === compared.getFullYear();
    }
  };
};

export const dateDifference = (from: Date, to: Date): DateDifference => {
  const negative = from > to;
  const [start, end] = negative ? [to, from] : [from, to];
  const d = intervalToDuration({ start, end });
  const sign = negative ? -1 : 1;

  return {
    days: sign * (d.days ?? 0),
    months: sign * (d.months ?? 0),
    years: sign * (d.years ?? 0)
  };
};

export const getRelativeDateDifference = (fromDate: string, toDate?: string): DateDifference =>
  dateDifference(parseDate(fromDate), parseDate(toDate ?? getToday()));

export const differenceInCalendarDays = (date: string, referenceDate: string): number =>
  dfnsDifferenceInCalendarDays(parseDate(date), parseDate(referenceDate));
